import { render } from "./RewardInput.vue?vue&type=template&id=e71643d0&scoped=true"
import script from "./RewardInput.vue?vue&type=script&lang=js"
export * from "./RewardInput.vue?vue&type=script&lang=js"

import "./RewardInput.vue?vue&type=style&index=0&id=e71643d0&scoped=true&lang=scss"

import exportComponent from "/var/www/gift/data/www/giftxyz.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e71643d0"]])

export default __exports__